import { AxiosResponse } from 'axios';
import { MessageResponse } from '@rossum/mdh-api-client';

const getStringHeader = (value: unknown): string | null => {
  return typeof value === 'string' ? value : null;
};

export const getTaskIdFromResponse = (
  response: AxiosResponse<MessageResponse>
): string | null => {
  const location = getStringHeader(response.headers['location']);

  return location?.split('/').pop() ?? null;
};
